export default {
  ROOT: 'root',
  TOWER: 'tower',
  LEVEL: 'level',
  UNIT: 'unit',
  POINT_OF_INTEREST: 'point-of-interest',
  NEIGHBOURHOOD_SUBDIVISION: 'neighbourhood-subdivision',
}
